var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"leading-tight"},[_vm._t("type")],2),_c('div',{staticClass:"leading-tight text-xs lowercase text-gray-600 font-normal italic"},[_vm._t("by")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }